import { render, staticRenderFns } from "./advancedShippingNoteDetail.vue?vue&type=template&id=4518fec0&scoped=true&"
import script from "./advancedShippingNoteDetail.vue?vue&type=script&lang=js&"
export * from "./advancedShippingNoteDetail.vue?vue&type=script&lang=js&"
import style0 from "./advancedShippingNoteDetail.vue?vue&type=style&index=0&id=4518fec0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4518fec0",
  null
  
)

export default component.exports